<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../../component/common/Value/ArraySlotView.svelte";
    import AddButtonView from "../../../component/common/Button/AddButtonView.svelte";
    import AppEditDialogView from "./AppEditDialogView.svelte";
    import AppPanelView from "./AppPanelView.svelte";
    import {EnvStore} from "../../../store/EnvStore";

    export let space;

    $: osType = EnvStore.osType;
    $: isSmartPhone = (() => {
        return EnvStore.isSmartPhone($osType);
    })();

    let editData = null;
    let isLoading = false;
    let apps = null;
    onMount(() => {
        loadData();
    });

    function loadData() {
        const paramMap = {};
        paramMap['space_id'] = space.id;
        paramMap['include_latest_binary'] = undefined;
        const url = UrlUtil.createApiUrl("app", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            apps = body['apps'];


        });
    }

    function onClickAdd() {
        editData = {
            space_id: space.id
        };
    }

    function onEdit(event) {
        const app = event.detail.app;
        editData = {...app};
    }

</script>

<div class="app-list-view">
    <LoadingContentView isLoading={isLoading} isCenter={true}>
        <div class="app-list-content">
            {#if !isSmartPhone}
                <div class="add-button-area">
                    <AddButtonView on:click={onClickAdd}/>
                </div>
            {/if}

            <ArraySlotView array={apps}>
                <div class="app-list-area">


                    {#each apps as app}
                        <AppPanelView space={space} app={app} on:edit={onEdit}/>
                    {/each}


                </div>

            </ArraySlotView>
        </div>


    </LoadingContentView>


</div>

<AppEditDialogView
        space={space}
        editData={editData}
        on:update={loadData}
        on:close={()=>{
            editData = null;
        }}

/>
<style lang="scss">
    .app-list-view {

        .app-list-content {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .add-button-area {
                text-align: right;
            }

            .app-list-area {
                display: flex;
                gap: 16px;
                flex-wrap: wrap;

            }
        }


    }
</style>